<ngx-datatable #table class='material striped' [loadingIndicator]="loadingIndicator" [columns]="columns"
  [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" [rowHeight]="'auto'" [rows]='rows'
  (activate)="onSelect($event)" [limit]="params.per_page" (sort)="onSort($event)">

  <ngx-datatable-column name="#" prop="avatar" [sortable]="false" [width]="30">
    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
      <img class="avatar" [alt]="row.name" [src]="row.url_avatar" />
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Cod. AAI" prop="codigo_aai" [sortable]="false" [width]="30">
    <ng-template let-rowIndex="rowIndex" let-codigo_aai="value" ngx-datatable-cell-template>
      {{codigo_aai}}
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Nome" prop="name" [sortable]="true">
    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>

      {{row.name}}
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Grupo" prop="role_id" [sortable]="true">
    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
      {{row.role.name}}
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="E-mail" prop="email" [sortable]="false">
    <ng-template let-rowIndex="rowIndex" let-email="value" ngx-datatable-cell-template>
      {{email}}
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Escritório" prop="escritorio_id" [sortable]="true">
    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
      {{ getNameEscritorio(row.escritorio)}}
    </ng-template>
  </ngx-datatable-column>

</ngx-datatable>

<div style="padding: 5px 10px">
  <mat-paginator #paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
    (page)="pageEvent($event)">
  </mat-paginator>
</div>